import Header from '../Header';
import NewsTicker from '../NewsTicker';
import Footer from '../Footer';
import { POLLSTERS } from '../../data/surveys';
import { usePageMeta } from '../../lib/pageMeta';
import SummaryStrip from './SummaryStrip';
import MethodologyGrid from './MethodologyGrid';
import ChartCard from './ChartCard';
import ChartLegend from './charts/ChartLegend';
import RawChart from './charts/RawChart';
import InspectionTable from './InspectionTable';
import ByTheNumbers from './ByTheNumbers';
import './Surveys.css';

// Hard-coded to the date the most recent poll was added to the dataset.
// Bump this whenever POLLS gets a new entry.
const LAST_UPDATED_LABEL = 'Last updated: 2 May 2026';

const SURVEYS_META = {
  title: 'Malta election polls — Lovin Malta election 2026',
  description:
    "Every published Malta election survey since the 2024 EP vote, side-by-side methodology, and three trajectory methods compared. Updated through the 2026 campaign.",
  canonical: 'https://lovinmalta.com/election2026/surveys',
};

const RAW_CHART_LEGEND = [
  { label: 'MaltaToday', color: POLLSTERS.MaltaToday.color, style: 'line+dot' as const },
  {
    label: 'Sagalytics (Marmarà)',
    color: POLLSTERS.Sagalytics.color,
    style: 'line+dot' as const,
  },
  {
    label: 'Esprimi (Times of Malta)',
    color: POLLSTERS['Esprimi (Times of Malta)'].color,
    style: 'line+dot' as const,
  },
  { label: 'EP Election 2024 actual result', color: '#b8860b', style: 'dot' as const },
];

export default function SurveysPage() {
  usePageMeta(SURVEYS_META);

  return (
    <>
      <div className="site-top">
        <Header />
        <NewsTicker />
      </div>
      <main className="surveys-page">
        <div className="surveys-page__inner">
          <h1 className="surveys-page__title">
            All of Malta&apos;s <em>Polls</em>, In One Place
          </h1>
          <p className="surveys-page__subtitle">
            EP election (8 June 2024) → present
          </p>

          <p className="surveys-page__intro">
            Three pollsters drive Malta&apos;s political conversation —
            MaltaToday, the Times of Malta, and Marmarà. Each has called
            elections right; each has missed. The honest take isn&apos;t
            picking one — it&apos;s reading them side by side.
          </p>

          <SummaryStrip />

          <InspectionTable />

          <ChartCard legend={<ChartLegend items={RAW_CHART_LEGEND} />}>
            <RawChart mode="fullscreen" />
          </ChartCard>

          <h2 className="surveys-page__h2">Pollster methodology</h2>
          <MethodologyGrid />

          <ByTheNumbers />

          <p className="surveys-page__updated">{LAST_UPDATED_LABEL}</p>
        </div>
      </main>
      <Footer />
    </>
  );
}
